<template>
  <div class="position-ab">
    <div
      :class="
        activeName == 4
          ? 'ccui-app-box-iframe-operate-container'
          : 'ccui-app-iframe-no-operate-container'
      "
    >
      <breadcrumbSourcing
        :breadcrumb-data="breadcrumbData"
      ></breadcrumbSourcing>
      <div
        :class="
          activeName == 4
            ? 'ccui-app-iframe-container-detail'
            : 'ccui-app-iframe-container-no-operate-detail'
        "
      >
        <div class="ccui-app-iframe-container-detail-body">
          <el-tabs v-model="activeName" class="el-tabs__customize">
            <el-tab-pane
              :label="
                `${
                  purchaseType == 1 ||
                  purchaseType == 4 ||
                  purchaseType == 7 ||
                  purchaseType == 8
                    ? '开启'
                    : '开标'
                }情况记录表`
              "
              name="2"
              id="table1"
            >
              <el-button
                type="primary"
                class="exportBtn"
                @click="
                  exportDefault(tableData[Number(active1)].packName, tableData)
                "
                ><b>Excel导出</b></el-button
              >
              <el-tabs v-model="active1" v-if="subPackageFlag">
                <template v-for="(item, index) in tableData">
                  <el-tab-pane
                    :label="item.packName"
                    :key="item.packId"
                    :name="index + ''"
                  >
                    <el-table
                      class="dic-sub-table-style01"
                      border
                      :cell-style="cellStyle"
                      :data="item.sscSupQuoteListBOS"
                      :span-method="spanMethod"
                    >
                      <el-table-column width="100" label="序号" align="center">
                        <template slot-scope="scope">
                          <span>{{
                            scope.row.label ? scope.row.label : scope.$index + 1
                          }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="supName"
                        label="分包商名称"
                        width="280"
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        label="采购风险等级"
                        minWidth="120"
                        align="center"
                        prop="ygyPurchaseRiskLevelStr"
                      ></el-table-column>
                      <el-table-column
                        prop="ygyReportUrl"
                        :show-overflow-tooltip="true"
                        width="180"
                        label="报告链接"
                      >
                        <template slot-scope="scope">
                          <span
                            class="ddd"
                            v-if="scope.row.ygyReportUrl"
                            @click="downloadEnclosure(scope.row.ygyReportUrl)"
                          >
                            {{ scope.row.ygyReportUrl }}
                          </span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="行业类型"
                        width="120"
                        prop="industryTypeName"
                        :show-overflow-tooltip="true"
                      ></el-table-column>
                      <el-table-column
                        label="企业规模"
                        width="120"
                        prop="companyTypeName"
                        :show-overflow-tooltip="true"
                      ></el-table-column>
                      <el-table-column
                        prop="amount"
                        align="right"
                        :label="`含税金额（${moneyData.unit}）`"
                        width="280"
                      >
                        <template slot-scope="{ row }">
                          <span
                            class="heighlight"
                            @click="handleSupply(row, item)"
                          >
                            {{ new BigNumber(row.priceAmount).toFormat(2) }}
                          </span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="amount"
                        align="right"
                        :label="`不含税金额（${moneyData.unit}）`"
                        width="280"
                      >
                        <template slot-scope="{ row }">
                          <!--  <span
                            class="heighlight"
                            @click="handleSupply(row, item)"
                          >
                            {{
                              new BigNumber(row.noTaxPriceAmount).toFormat(2)
                            }}
                          </span> -->
                          {{ new BigNumber(row.noTaxPriceAmount).toFormat(2) }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="taxAmount"
                        align="right"
                        :label="`税额（${moneyData.unit}）`"
                        width="200"
                      >
                        <template slot-scope="{ row }">
                          <!-- <span
                            class="heighlight"
                            @click="handleSupply(row, item)"
                          >
                            {{ new BigNumber(row.taxAmount).toFormat(2) }}
                          </span> -->
                          {{ new BigNumber(row.taxAmount).toFormat(2) }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="workMonth"
                        show-overflow-tooltip
                        width="120"
                      >
                        <template slot="header">
                          <span class="star">*</span><span>{{ Myunit }}</span>
                        </template>
                        <template slot-scope="{ row }">
                          <span>{{ row.workMonth }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="isAuthorization"
                        show-overflow-tooltip
                        width="230"
                      >
                        <template slot="header">
                          <span class="star">*</span
                          ><span>法定代表人资格证书或授权书</span>
                        </template>
                        <template slot-scope="{ row }">
                          <span>{{
                            row.isAuthorization === 1 ? "有" : "无"
                          }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="isMarginAmount"
                        show-overflow-tooltip
                        width="180"
                        v-if="item.bidMarginFlag === '1'"
                      >
                        <template slot="header">
                          <span class="star">*</span
                          ><span>{{
                            `${
                              purchaseType == 1 ||
                              purchaseType == 2 ||
                              purchaseType == 4 ||
                              purchaseType == 7 ||
                              purchaseType == 8
                                ? "响应"
                                : "投标"
                            }保证金递交情况`
                          }}</span>
                        </template>
                        <template slot-scope="{ row }">
                          <span v-if="row.isMarginAmount === 1">已交</span>
                          <span class="star" v-else>未交</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="personnelEquipment"
                        show-overflow-tooltip
                        width="160"
                      >
                        <template slot="header">
                          <span class="star">*</span
                          ><span>投入的人员设备情况</span>
                        </template>
                      </el-table-column>
                      <el-table-column width="120">
                        <template slot="header">
                          <span class="star">*</span><span>是否有效标书</span>
                        </template>
                        <template slot-scope="{ row }">
                          <!--有法定代表人资格证书或授权书，且收取投标保证金并且已交的情况为是，否则为否-->
                          <span>{{ row.isValidBids === 1 ? "是" : "否" }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-tab-pane>
                </template>
              </el-tabs>
              <template v-else v-for="(item, index) in tableData">
                <el-table
                  :key="index"
                  class="dic-sub-table-style01"
                  :cell-style="cellStyle"
                  border
                  :data="item.sscSupQuoteListBOS"
                  :span-method="spanMethod"
                >
                  <el-table-column width="100" label="序号" align="center">
                    <template slot-scope="scope">
                      <span>{{
                        scope.row.label ? scope.row.label : scope.$index + 1
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="supName"
                    label="分包商名称"
                    width="200"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    label="采购风险等级"
                    minWidth="120"
                    align="center"
                    prop="ygyPurchaseRiskLevelStr"
                  ></el-table-column>
                  <el-table-column
                    prop="ygyReportUrl"
                    :show-overflow-tooltip="true"
                    width="180"
                    label="报告链接"
                  >
                    <template slot-scope="scope">
                      <span
                        class="ddd"
                        v-if="scope.row.ygyReportUrl"
                        @click="downloadEnclosure(scope.row.ygyReportUrl)"
                      >
                        {{ scope.row.ygyReportUrl }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="行业类型"
                    width="120"
                    prop="industryTypeName"
                    :show-overflow-tooltip="true"
                  ></el-table-column>
                  <el-table-column
                    label="企业规模"
                    width="120"
                    prop="companyTypeName"
                    :show-overflow-tooltip="true"
                  ></el-table-column>
                  <el-table-column
                    prop="amount"
                    align="right"
                    :label="`含税金额（${moneyData.unit}）`"
                    width="280"
                  >
                    <template slot-scope="{ row }">
                      <span class="heighlight" @click="handleSupply(row, item)">
                        {{ new BigNumber(row.priceAmount).toFormat(2) }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="amount"
                    align="right"
                    :label="`不含税金额（${moneyData.unit}）`"
                    width="280"
                  >
                    <template slot-scope="{ row }">
                      <!--  <span
                            class="heighlight"
                            @click="handleSupply(row, item)"
                          >
                            {{
                              new BigNumber(row.noTaxPriceAmount).toFormat(2)
                            }}
                          </span> -->
                      {{ new BigNumber(row.noTaxPriceAmount).toFormat(2) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="taxAmount"
                    align="right"
                    :label="`税额（${moneyData.unit}）`"
                    width="200"
                  >
                    <template slot-scope="{ row }">
                      <!-- <span
                            class="heighlight"
                            @click="handleSupply(row, item)"
                          >
                            {{ new BigNumber(row.taxAmount).toFormat(2) }}
                          </span> -->
                      {{ new BigNumber(row.taxAmount).toFormat(2) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="workMonth"
                    show-overflow-tooltip
                    width="120"
                  >
                    <template slot="header">
                      <span class="star">*</span><span>{{ Myunit }}</span>
                    </template>
                    <template slot-scope="{ row }">
                      <span>{{ row.workMonth }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="isAuthorization"
                    show-overflow-tooltip
                    width="230"
                  >
                    <template slot="header">
                      <span class="star">*</span
                      ><span>法定代表人资格证书或授权书</span>
                    </template>
                    <template slot-scope="{ row }">
                      <span>{{ row.isAuthorization === 1 ? "有" : "无" }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="isMarginAmount"
                    show-overflow-tooltip
                    width="180"
                    v-if="item.bidMarginFlag === '1'"
                  >
                    <template slot="header">
                      <span class="star">*</span
                      ><span>{{
                        `${
                          purchaseType == 1 ||
                          purchaseType == 2 ||
                          purchaseType == 4 ||
                          purchaseType == 7 ||
                          purchaseType == 8
                            ? "响应"
                            : "投标"
                        }保证金递交情况`
                      }}</span>
                    </template>
                    <template slot-scope="{ row }">
                      <span v-if="row.isMarginAmount === 1">已交</span>
                      <span class="star" v-else>未交</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="personnelEquipment"
                    show-overflow-tooltip
                    width="160"
                  >
                    <template slot="header">
                      <span class="star">*</span><span>投入的人员设备情况</span>
                    </template>
                  </el-table-column>
                  <el-table-column width="120">
                    <template slot="header">
                      <span class="star">*</span><span>是否有效标书</span>
                    </template>
                    <template slot-scope="{ row }">
                      <!--有法定代表人资格证书或授权书，且收取投标保证金并且已交的情况为是，否则为否-->
                      <span>{{ row.isValidBids === 1 ? "是" : "否" }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-tab-pane>
            <el-tab-pane
              :label="
                `${
                  purchaseType == 1 ||
                  purchaseType == 4 ||
                  purchaseType == 7 ||
                  purchaseType == 8
                    ? '开启'
                    : '开标'
                }一览表`
              "
              name="1"
              id="table2"
            >
              <template>
                <template v-if="subPackageFlag">
                  <el-tabs v-model="activeName1">
                    <el-tab-pane
                      v-for="(item_, index_) in tableData"
                      :key="item_.packId"
                      :label="item_.packName"
                      :name="index_ + ''"
                    >
                      <el-button
                        type="primary"
                        class="exportBtn"
                        @click="
                          exportLogin(
                            item_.packName,
                            bidOpenTableData[index_].sscSupQuoteListBOS
                          )
                        "
                        ><b>Excel导出</b></el-button
                      >
                      <div
                        v-if="
                          bidOpenTableData[index_].repeatPersonSub &&
                            bidOpenTableData[index_].repeatPersonSub.length > 0
                        "
                        class="pao"
                      >
                        <div>温馨提示：</div>
                        <div
                          v-for="(item, index) in bidOpenTableData[index_]
                            .repeatPersonSub"
                          :key="index"
                          style="display: flex"
                        >
                          <div style="flex: 1">{{ item.message }}</div>
                          <div
                            style="
                              width: 120px;
                              text-align: right;
                              z-index: 100;
                            "
                          >
                            <span
                              @click="showRow(item)"
                              style="
                                font-size: 12px;
                                color: #0089ef;
                                cursor: pointer;
                              "
                              >查看详情</span
                            >
                          </div>
                        </div>
                      </div>
                      <el-table
                        :data="bidOpenTableData[index_].sscSupQuoteListBOS"
                        border
                      >
                        <el-table-column
                          v-for="(item, index) in bidOpenTableColumns"
                          :key="index"
                          :show-overflow-tooltip="true"
                          v-bind="item"
                          :align="
                            item.label == '税额' ||
                            item.label.includes('不含税金额') ||
                            item.label.includes('含税金额')
                              ? 'right'
                              : 'left'
                          "
                        >
                          <template slot-scope="{ row }">
                            <template v-if="item.isCal">
                              <template v-if="item.prop === 'priceAmount'">
                                <div class="priceClass">
                                  <span
                                    class="heighlight"
                                    @click="handleSupply(row, item_)"
                                    >{{
                                      new BigNumber(row[item.prop]).toFormat(2)
                                    }}</span
                                  >
                                </div>
                              </template>
                              <div class="priceClass" v-else>
                                <span>{{
                                  getAmountCount(item.prop, row[item.prop])
                                }}</span>
                              </div>
                            </template>
                            <el-button
                              v-if="item.type == 'link'"
                              size="mini"
                              type="text"
                              @click="handleSupply(row)"
                              >{{
                                new BigNumber(row[item.prop]).toFormat(2)
                              }}</el-button
                            >
                            <span v-else-if="getAmountCountShow(item.prop)"
                              >{{ getAmountCount(item.prop, row[item.prop]) }}
                            </span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-tab-pane>
                  </el-tabs>
                </template>
                <template v-else>
                  <el-button
                    type="primary"
                    class="exportBtn"
                    @click="
                      exportLogin(
                        `${
                          purchaseType == 1 ||
                          purchaseType == 4 ||
                          purchaseType == 7 ||
                          purchaseType == 8
                            ? '开启'
                            : '开标'
                        }一览表`,
                        bidOpenTableData[0].sscSupQuoteListBOS
                      )
                    "
                    ><b>Excel导出</b></el-button
                  >

                  <div
                    v-if="
                      bidOpenTableData[0].repeatPersonSub &&
                        bidOpenTableData[0].repeatPersonSub.length > 0
                    "
                    class="pao"
                  >
                    <div>温馨提示：</div>
                    <div
                      v-for="(item, index) in bidOpenTableData[0]
                        .repeatPersonSub"
                      :key="index"
                      style="display: flex"
                    >
                      <div style="flex: 1">{{ item.message }}</div>
                      <div
                        style="width: 120px; text-align: right; z-index: 100"
                      >
                        <span
                          @click="showRow(item)"
                          style="
                            font-size: 12px;
                            color: #0089ef;
                            cursor: pointer;
                          "
                          >查看详情</span
                        >
                      </div>
                    </div>
                  </div>
                  <el-table
                    :data="bidOpenTableData[0].sscSupQuoteListBOS"
                    border
                  >
                    <el-table-column
                      v-for="(item, index) in bidOpenTableColumns"
                      :key="index"
                      :show-overflow-tooltip="true"
                      v-bind="item"
                      :align="
                        item.label == '税额' ||
                        item.label.includes('不含税金额') ||
                        item.label.includes('含税金额')
                          ? 'right'
                          : item.label == '序号'
                          ? 'center'
                          : 'left'
                      "
                    >
                      <template slot-scope="{ row }">
                        <template v-if="item.isCal">
                          <template v-if="item.prop === 'priceAmount'">
                            <div class="priceClass">
                              <span
                                class="heighlight"
                                @click="handleSupply(row)"
                                >{{
                                  new BigNumber(row[item.prop]).toFormat(2)
                                }}</span
                              >
                            </div>
                          </template>
                          <div class="priceClass" v-else>
                            <span>{{
                              getAmountCount(item.prop, row[item.prop])
                            }}</span>
                          </div>
                        </template>
                        <el-button
                          v-if="item.type == 'link'"
                          size="mini"
                          type="text"
                          @click="handleSupply(row)"
                          >{{
                            new BigNumber(row[item.prop]).toFormat(2)
                          }}</el-button
                        >
                        <span v-else-if="getAmountCountShow(item.prop)"
                          >{{ getAmountCount(item.prop, row[item.prop]) }}
                        </span>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </template>
            </el-tab-pane>
            <el-tab-pane label="报价一览表" name="3">
              <supplierQuoteList></supplierQuoteList>
            </el-tab-pane>
            <el-tab-pane
              :label="
                `${
                  purchaseType == 1 ||
                  purchaseType == 4 ||
                  purchaseType == 7 ||
                  purchaseType == 8
                    ? '开启'
                    : '开标'
                }情况`
              "
              name="4"
            >
              <openTenderDetailList></openTenderDetailList>
            </el-tab-pane>

            <el-tab-pane label="分包商投标信息预警" name="5">
              <tenderWarning></tenderWarning>
            </el-tab-pane>
            <!--投标单位关联关系查询、投标人关联关系查询-->
            <el-tab-pane label="投标人关联关系查询" name="6">
              <associationList></associationList>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <!-- <template v-if="activeName == 4">
        <div class="operate">
          <el-button type="text" icon="icon-ccui-print" @click="muchDownload"
            >批量下载</el-button
          >
        </div>
      </template> -->
      <el-dialog
        :visible.sync="supplierBidDetailsdialogVisible"
        :title="
          `分包商${
            purchaseType == 1 ||
            purchaseType == 2 ||
            purchaseType == 4 ||
            purchaseType == 7 ||
            purchaseType == 8
              ? '响应'
              : '投标'
          }详细信息`
        "
        width="1200px"
        v-if="supplierBidDetailsdialogVisible"
      >
        <supplierBidDetails
          :supQuoteId="formData.supQuoteId"
          :supCode="formData.supCode"
          :supPackQuoteId="formData.supPackQuoteId"
          :packId="formData.packId"
        ></supplierBidDetails>
        <div slot="footer"></div>
      </el-dialog>
    </div>

    <el-dialog
      append-to-body
      title="人员信息"
      fontWeight="500"
      :visible.sync="showUser"
      width="75%"
    >
      <div class="box">
        <div class="box1">
          <div style="padding: 10px 0">
            {{ userList1.subName }}
          </div>
          <el-table
            ref="userListTable"
            class="dic-sub-table-style01"
            :data="userList1.personList"
            style="width: 100%; max-height: 450px; overflow: auto"
            border
          >
            <el-table-column type="index" label="序号" width="50">
              <template slot-scope="{ $index, row }">
                <span :class="row.repeatFlag == 1 ? 'red' : ''">
                  {{ $index + 1 }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="personName"
              label="姓名"
              :show-overflow-tooltip="true"
              width="80"
            >
              <template slot-scope="scope">
                <span :class="scope.row.repeatFlag == 1 ? 'red' : ''">{{
                  scope.row.personName
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="idCard"
              label="证件号码"
              :show-overflow-tooltip="true"
              width="170"
            >
              <template slot-scope="scope">
                <span :class="scope.row.repeatFlag == 1 ? 'red' : ''">{{
                  scope.row.idCard
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="phone"
              label="手机号码"
              :show-overflow-tooltip="true"
              width="120"
            >
              <template slot-scope="scope">
                <span :class="scope.row.repeatFlag == 1 ? 'red' : ''">{{
                  scope.row.phone
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="subPersonTypeStr"
              label="类型"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span :class="scope.row.repeatFlag == 1 ? 'red' : ''">{{
                  scope.row.subPersonTypeStr
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="free1"
              label="注册地址"
              :show-overflow-tooltip="true"
              width="150"
            >
              <template slot-scope="scope">
                <span :class="scope.row.repeatFlag == 1 ? 'red' : ''">{{
                  scope.row.free1
                }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="box1">
          <div style="padding: 10px 0">
            {{ userList2.subName }}
          </div>
          <el-table
            ref="userListTable"
            class="dic-sub-table-style01"
            :data="userList2.personList"
            style="width: 100%; max-height: 450px; overflow: auto"
            border
          >
            <el-table-column type="index" label="序号" width="50">
              <template slot-scope="{ $index, row }">
                <span :class="row.repeatFlag == 1 ? 'red' : ''">
                  {{ $index + 1 }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="personName"
              label="姓名"
              :show-overflow-tooltip="true"
              width="80"
            >
              <template slot-scope="scope">
                <span :class="scope.row.repeatFlag == 1 ? 'red' : ''">{{
                  scope.row.personName
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="idCard"
              label="证件号码"
              :show-overflow-tooltip="true"
              width="170"
            >
              <template slot-scope="scope">
                <span :class="scope.row.repeatFlag == 1 ? 'red' : ''">{{
                  scope.row.idCard
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="phone"
              label="手机号码"
              :show-overflow-tooltip="true"
              width="120"
            >
              <template slot-scope="scope">
                <span :class="scope.row.repeatFlag == 1 ? 'red' : ''">{{
                  scope.row.phone
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="subPersonTypeStr"
              label="类型"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span :class="scope.row.repeatFlag == 1 ? 'red' : ''">{{
                  scope.row.subPersonTypeStr
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="free1"
              label="注册地址"
              :show-overflow-tooltip="true"
              width="150"
            >
              <template slot-scope="scope">
                <span :class="scope.row.repeatFlag == 1 ? 'red' : ''">{{
                  scope.row.free1
                }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer">
        <el-button size="mini" type="default-mini" @click="showUser = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible" width="1000px" height="70vh">
      <iframe
        :src="reportUrl"
        frameborder="0"
        height="100%"
        width="100%"
      ></iframe>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          type="default-mini"
          @click="dialogVisible = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinSys } from "@/app/subSourcingFlow/mixins/mixinSys";

import BigNumber from "bignumber.js";
import breadcrumbSourcing from "@/app/subSourcingFlow/components/breadcrumb-sourcing.vue";
import supplierBidDetails from "@/app/subSourcingFlow/views/supplierBidDetails.vue";
import supplierQuoteList from "@/app/subSourcingFlow/views/supplierQuoteList.vue";
import openTenderDetailList from "./openTenderDetailList.vue";
import tenderWarning from "./tenderWarning.vue";
import associationList from "./associationList.vue";

import {
  scpQryCurrentRoundSupPriceApi,
  scpListPurchaseSchemePackageApi,
  scpQryBidPriceSupListApi,
  scpQryFileinfoListApi,
  scpQryBidPricePrepareApi,
  querySupQuotePersonDetail,
  scpQryBidOpenRecord
  // scpQryNoticeDetailApi
} from "@/app/sourcingFlow/api/scp-expertEvaluation.js";
import { exportJsonToExcel } from "@/basa/utils/Export2Excel";
import { addUrlPerFix } from "@/basa/utils";
import fineReport from "@/config/mixins/fineReport.js";
// 引入导出Excel表格依赖
const ExcelJS = require("exceljs");
import { saveAs } from "file-saver";
export default {
  name: "bidOpenSituation",
  components: {
    breadcrumbSourcing,
    supplierBidDetails,
    tenderWarning,
    associationList,
    openTenderDetailList,
    supplierQuoteList
  },
  mixins: [fineReport, mixinSys],
  data() {
    let unit = JSON.parse(sessionStorage.getItem("moneyData")).unit;
    return {
      BigNumber: BigNumber,
      userList1: [],
      userList2: [],
      showUser: false,
      breadcrumbData: {
        titname: "开标情况"
      },
      sscSupQuoteListBOSList: [],
      Myunit: "工期（月）",
      moneyData: JSON.parse(sessionStorage.getItem("moneyData")),
      purchaseType: JSON.parse(sessionStorage.getItem("expertSourceData"))
        .purchaseType, // 招标方式
      dialogVisible: false,
      activeName: "2",
      bidOpenRecordsList: [],
      bidOpenTableList: [],
      bidOpenTableData: [], // 开标一览表
      bidOpenPackHeaders: [], // 开标一览表表头
      supplierQuotationActiveName: "1",
      fileTableData: [], // 文件
      bidOpenTableColumns: [
        {
          prop: "id",
          label: "序号",
          width: 50,
          align: "center"
        },
        {
          prop: "supName",
          label: "分包商",
          width: 250
          // type: "link"
        },
        {
          prop: "industryTypeName",
          label: "行业类型",
          width: 120
        },
        {
          prop: "companyTypeName",
          label: "企业规模",
          width: 120
        },
        {
          prop: "taxAmount",
          label: "税额",
          isCal: true,
          align: "center",
          width: 220
        },
        {
          prop: "noTaxPriceAmount",
          label: "不含税金额（" + unit + "）",
          isCal: true,
          align: "right",
          width: 220
        },
        {
          prop: "priceAmount",
          label: "含税金额（" + unit + "）",
          isCal: true,
          align: "right",
          width: 220
        },
        {
          prop: "contractName",
          label: "联系人",
          width: 110
        },
        {
          prop: "mobile",
          label: "手机号",
          width: 110
        },
        {
          prop: "priceTime",
          label: "投标时间",
          width: 170
        }
      ],
      formData: {
        supQuoteId: 0, // 分包商报价ID
        supPackQuoteId: "",
        supCode: "", // 分包商编号
        packId: "" //包件Id
      },
      supplierBidDetailsdialogVisible: false,
      selectData: [], // 选择批量下载文件
      bidOpenExportHeaders: [], // 导出的开标一览表表头
      bidOpenExportColumns: [], // 导出的开标一览表columns
      bidOpenExportProps: [], // 导出的开标一览表Props
      packList: [],
      noticeInfoData: {
        textInfo: "",
        fileinfoBOS: []
      },
      quoteDetailsActive: "0",
      quoteDetailsFrameLoading: true,
      quoteDetailsListFrameLoading: true,
      subPackageFlag: false, //true分包，false不分包
      tableData: [], //开标情况记录表data
      active: "0",
      active1: "0",
      activeName1: "0",
      reportListUrl: "",
      exportParams: {
        fileName: "",
        flag: ""
      }
    };
  },
  created() {
    this.getData();
  },
  watch: {
    activeName: {
      handler(newVal, oldVal) {
        if (newVal == 1) {
          this.exportParams = {
            fileName: `${
              this.purchaseType == 1 ||
              this.purchaseType == 4 ||
              this.purchaseType == 7 ||
              this.purchaseType == 8
                ? "开启"
                : "开标"
            }一览表`,
            flag: "table2"
          };
        } else if (newVal == 2) {
          this.exportParams = {
            fileName: `${
              this.purchaseType == 1 ||
              this.purchaseType == 4 ||
              this.purchaseType == 7 ||
              this.purchaseType == 8
                ? "开启"
                : "开标"
            }情况记录表`,
            flag: "table1"
          };
        }
      },
      immediate: true
    },
    purchaseType: {
      handler(newVal) {
        if (newVal == 1 || newVal == 4 || newVal == 7 || newVal == 8) {
          this.breadcrumbData.titname = "开启情况";
          this.bidOpenTableColumns.forEach(item => {
            if (item.prop == "priceTime") {
              item.label = "响应时间";
            }
          });
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    /* getAAAA(data, id) {
      console.log("data", data, "id", id);
      return true;
    }, */
    getAmountCountShow(data) {
      let arr = ["taxAmount", "priceAmount", "noTaxPriceAmount"];
      if (arr.includes(data)) {
        // console.log(data);
        return false;
      } else return true;
      // console.log(data);
    },
    getAmountCount(prop, data) {
      let arr = ["taxAmount", "priceAmount", "noTaxPriceAmount"];
      if (arr.includes(prop)) {
        // console.log(data);
        return new BigNumber(data).toFormat(2);
      } else {
        // console.log(data);
        return data;
      }
    },
    getItemBidOpenTableData(data) {
      console.log("data111", data);
    },
    getBidOpenRecordsList(data) {
      this.bidOpenRecordsList = JSON.parse(JSON.stringify(data));
      // console.log("this.bidOpenRecordsList ", this.bidOpenRecordsList);
      return false;
    },
    reportTabChange({ id }) {
      console.log(id);
      //reportListUrl
    },
    calculateFun(data, attr, index) {
      let money = 0;
      if (data.sscSupPackPriceBOS[0][attr] == null) {
        data.sscSupPackPriceBOS[0][attr] = "0.00000000";
      }
      if (data.sscSupPackPriceBOS.length > 1) {
        money = data.sscSupPackPriceBOS.reduce((pre, next) => {
          let obj = {};
          obj[attr] = window.$computeUtil.getPlus(pre[attr], next[attr]);
          return obj;
        })[attr];
      } else if (data.sscSupPackPriceBOS.length === 1) {
        money = data.sscSupPackPriceBOS[0][attr];
      }
      // console.log(this.bidOpenTableData[index]);
      // console.log("bidOpenTableList", this.bidOpenTableList);
      this.bidOpenTableList[index][attr] = money
        ? new BigNumber(money).toFormat(2)
        : "";
      if (new BigNumber(money).toFormat(2) == "NaN") {
        /*  console.log("money", money);
        console.log("data.sscSupPackPriceBOS", data.sscSupPackPriceBOS);
        console.log("attr", attr);
        console.log(
          "data.sscSupPackPriceBOS[0][attr]",
          data.sscSupPackPriceBOS[0][attr]
        ); */

        // return new BigNumber(data.sscSupPackPriceBOS[0][attr]).toFormat(2);
        return new BigNumber(data.sscSupPackPriceBOS[0][attr]).toFormat(2);
      }
      /* return new BigNumber(money).toFormat(2) == "NaN"
        ? "0.00000000"
        : new BigNumber(money).toFormat(2); */
      return new BigNumber(money).toFormat(2);
      // return money ? new BigNumber(money).toFormat(2) : "";
    },

    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (column.property === "ygyPurchaseRiskLevelStr") {
        switch (row.ygyPurchaseRiskLevelStr) {
          case "高风险":
            return {
              color: "#EB090C"
            };
          case "较高风险":
            return {
              color: "#dd7d00"
            };
          case "中风险":
            return {
              color: "#FFC273"
            };
          case "较低风险":
            return {
              color: "#4d8b0a"
            };
          case "低风险":
            return {
              color: "#b7f276"
            };
          default:
            return { color: "#4A4A4A" };
        }
      }
    },
    getData() {
      scpQryCurrentRoundSupPriceApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        purStep: "6"
      }).then(res => {
        console.log("res", res.data.data);
        scpListPurchaseSchemePackageApi({
          pageNo: -1,
          pageSize: -1,
          // schemeId: "7110534015167361024"
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId
        }).then(restow => {
          // 是否分包 1分包0不分包
          // 是否分包 1分包0不分包
          this.subPackageFlag =
            restow.data.data.subPackageFlag == "1" ? true : false;
          console.log(restow.data, "33333");
          if (restow.data.code === "0") {
            restow.data.data.purchaseSchemePackageList.forEach(item => {
              item.quoteDetailsListFrameLoading = true;
            });
            this.packList = restow.data.data.purchaseSchemePackageList;
            let labelChild = [];
            res.data.data.forEach((item, index) => {
              item.id = index + 1;
              item.sscSupPackPriceBOS.forEach((itemtow, indextow) => {
                itemtow.packStatusStr =
                  Number(itemtow.packStatus) !== 1 ? "（已流标）" : "";
                let propthis = "priceAmount" + itemtow.packId;
                item[propthis] = itemtow.priceAmount;
                if (
                  labelChild.filter(item => {
                    return item.prop === "priceAmount" + itemtow.packId;
                  }).length === 0
                ) {
                  labelChild.push({
                    prop: propthis,
                    label: itemtow.packName,
                    bidFlag: itemtow.bidFlag,
                    packStatusStr: itemtow.packStatusStr,
                    type: "link"
                  });
                }
              });
            });
            this.bidOpenTableColumns[2].labelChild = labelChild;
            console.log(this.bidOpenTableColumns);
            this.$set(this, "bidOpenTableData", res.data.data);
            /*  console.log("res.data.data", res.data.data);
            console.log("tableData", this.tableData);
            console.log(555);
            this.bidOpenTableList = JSON.parse(
              JSON.stringify(this.bidOpenTableData)
            );
            let j = JSON.parse(JSON.stringify(this.bidOpenTableData));
            console.log("j2", j);
            for (const obj of j) {
              const sscSupPackPriceBOS = obj.sscSupPackPriceBOS;
              for (const item of sscSupPackPriceBOS) {
                Object.assign(item, obj);
              }
            }
            console.log("j1", j);
            let k = [];
            j.forEach((item, index) => {
              item.sscSupPackPriceBOS.forEach(c => {
                k.push(c);
              });
            });
            console.log("j", j);
            const groupedArray = {};

            for (const obj of k) {
              const { packId } = obj;
              if (groupedArray[packId]) {
                groupedArray[packId].push(obj);
              } else {
                groupedArray[packId] = [obj];
              }
            }
            console.log(j);
            console.log(k);
            console.log(groupedArray);
            for (let i in groupedArray) {
              groupedArray[i].forEach((item, index) => {
                if (!item.supJoinId) {
                  groupedArray[i].splice(1, index);
                }
              });
            }
            console.log("groupedArray", Object.values(groupedArray)[0]);
            this.bidOpenTableData = groupedArray; */
          }
        });
      });
      // }

      // 开标情况记录表
      let ids = "7";
      if (this.$router.history.current.query.evaPurStep === "801") {
        ids = "0701";
      } else if (this.$router.history.current.query.evaPurStep === "802") {
        ids = "0702";
      }
      scpQryBidOpenRecord({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        purStep: ids
        // evaPurStep: this.$router.history.current.query.evaPurStep
      }).then(res => {
        if (res.data.code === "0") {
          this.sscSupQuoteListBOSList = JSON.parse(
            JSON.stringify(res.data.data.sscSupQuoteListResultBOS)
          );
          if (
            res.data.data.sscSupQuoteListResultBOS &&
            res.data.data.sscSupQuoteListResultBOS.length > 0
          ) {
            if (
              res.data.data.sscSupQuoteListResultBOS[0].sscSupQuoteListBOS[0]
                .dateUnit == "2"
            ) {
              this.Myunit = "工期（天）";
            } else {
              this.Myunit = "工期（月）";
            }
          }
          this.tableData = res.data.data.sscSupQuoteListResultBOS.map(item => {
            if (item.packStatus !== "1" && item.packName) {
              item.packName = item.packName + "（已流标）";
            }
            let arr = [
              {
                index: "downTwo",
                label: "采购交易工作小组会签",
                supName: item.workPersionNameStr
              },
              {
                index: "downOne",
                label: "监督人员会签",
                supName: item.supervisoryPersonNameStr
              }
            ];
            item.sscSupQuoteListBOS.push.apply(item.sscSupQuoteListBOS, arr);
            return item;
          });
          // this.bidOpenTableData = JSON.parse(JSON.stringify(this.tableData));
          console.log("this.bidOpenTableData", this.bidOpenTableData);
          /* console.log("this.tableData", this.tableData);
          let j = JSON.parse(JSON.stringify(this.bidOpenTableData));
          console.log("j2", j);
          for (const obj of j) {
            const sscSupPackPriceBOS = obj.sscSupPackPriceBOS;
            for (const item of sscSupPackPriceBOS) {
              Object.assign(item, obj);
            }
          }
          console.log("j1", j);
          let k = [];
          j.forEach((item, index) => {
            item.sscSupPackPriceBOS.forEach(c => {
              k.push(c);
            });
          });
          console.log("j", j);
          const groupedArray = {};

          for (const obj of k) {
            const { packId } = obj;
            if (groupedArray[packId]) {
              groupedArray[packId].push(obj);
            } else {
              groupedArray[packId] = [obj];
            }
          }
          // console.log(j);
          // console.log(k);
          // console.log(groupedArray);
          for (let i in groupedArray) {
            groupedArray[i].forEach((item, index) => {
              if (!item.supJoinId) {
                groupedArray[i].splice(1, index);
              }
            });
          }
          console.log("groupedArray", groupedArray); */
          console.log("sscSupQuoteListBOSList", this.sscSupQuoteListBOSList);

          this.sscSupQuoteListBOSList.forEach(item => {
            item.sscSupQuoteListBOS.forEach((ele, index) => {
              ele.id = index + 1;
            });
          });
          this.bidOpenTableData = this.sscSupQuoteListBOSList;
          console.log("this.bidOpenTableData", this.bidOpenTableData);
        }
      });
      scpQryBidPricePrepareApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        purStep: "6" // 寻源环节 开标环节：6谈判环节：11
      }).then(res => {
        // 文件
        scpQryBidPriceSupListApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          bidPriceId: res.data.data.bidPriceId
        }).then(res => {
          this.fileTableData = res.data.data;
        });
      });
    },

    showRow(row) {
      querySupQuotePersonDetail({ supQuoteIds: row.supQuoteIds }).then(res1 => {
        if (res1.data.code === "0") {
          this.userList1 = res1.data.data[0];
          this.userList1.supCode = res1.data.data[0].subCode;
          this.userList2 = res1.data.data[1];
          this.userList2.supCode = res1.data.data[1].subCode;
          this.showUser = true;
        }
      });
    },

    qryFileinfoList(fromItem) {
      return new Promise((resolve, reject) => {
        scpQryFileinfoListApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          billId: fromItem.supQuoteId,
          billType: "0603",
          uploadPhase: "0603"
        }).then(res => {
          if (res.data.data.length > 0) {
            res.data.data.forEach(item => {
              item.supQuoteId = fromItem.supQuoteId;
              item.supCode = fromItem.supCode;
              item.supName = fromItem.supName;
            });
          }
          resolve(res.data.data);
        });
      });
    },
    download(row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/bid/oss/downloadByUploadId?fileUrl=${
        row.fileUrl
      }&fileName=${encodeURIComponent(row.fileName)}`;
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    },
    selectChange(select) {
      this.selectData = select;
    },
    // 批量下载
    muchDownload() {
      let supQuoteInfoList = [];
      if (this.selectData.length === 0) {
        this.fileTableData.forEach(item => {
          supQuoteInfoList.push({
            supQuoteId: item.supQuoteId,
            supName: item.supName
          });
        });
      } else {
        this.selectData.forEach(item => {
          supQuoteInfoList.push({
            supQuoteId: item.supQuoteId,
            supName: item.supName
          });
        });
      }
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      let params = {
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        schemeCode: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeCode,
        supQuoteInfoList: supQuoteInfoList
      };
      let href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/bid/bidc/qrySupBiddingFileInfoList?reqBO=${JSON.stringify(
        params
      )}`;
      openUrl.href = encodeURI(href);
      console.log(openUrl.href);
      openUrl.setAttribute("download", "分包商投标文件.zip");
      document.body.appendChild(openUrl);
      openUrl.click();
    },
    //分包商跳转
    handleSupply(row, data) {
      this.formData.supPackQuoteId = row.supPackQuoteId;
      this.formData.supQuoteId = row.supQuoteId;
      this.formData.supCode = row.supCode;
      if (data) {
        this.formData.packId = data.packId;
      } else {
        this.formData.packId = "";
      }
      this.supplierBidDetailsdialogVisible = true;
    },
    exportPdf() {
      /*switch (this.activeName) {
        case "1":
          // 开标一览表
          this.exportBidOpenTableDataPdf();
          break;
        case "2":
          break;
        case "3":
          break;
        default:
          this.exportBidOpenTableDataPdf();
          break;
      }*/
    },
    // 开标一览表导出开始
    exportBidOpenTableDataPdf() {
      this.exportData = [];
      if (this.bidOpenTableData.length > 5000) {
        this.$message({
          message: "暂不支持5000行以上大批量数据导出",
          type: "warning",

          offset: document.documentElement.clientHeight / 2 - 21
        });
      } else {
        this.bidOpenTableData.forEach((item, index) => {
          this.exportData.push(item);
        });
        if (this.ExcelJS) {
          this.exportBidOpenDefaultAll();
        } else {
          this.exportBidOpenCompatibleAll();
        }
      }
    },
    async exportBidOpenDefaultAll() {
      const wb = new this.ExcelJS.Workbook();
      const ws1 = wb.addWorksheet(
        `${
          this.purchaseType == 1 ||
          this.purchaseType == 4 ||
          this.purchaseType == 7 ||
          this.purchaseType == 8
            ? "开启"
            : "开标"
        }一览表`
      );
      ws1.views = [{ state: "frozen", ySplit: 1 }];

      ws1.addRow([
        `${
          this.purchaseType == 1 ||
          this.purchaseType == 4 ||
          this.purchaseType == 7 ||
          this.purchaseType == 8
            ? "开启"
            : "开标"
        }一览表`
      ]);
      ws1.addRow([this.content]);
      ws1.addRow(this.bidOpenExportHeaders);
      ws1.columns = this.bidOpenExportColumns;
      this.exportData.forEach((table, index) => {
        let rowArr = [];
        this.bidOpenTableColumns.forEach(item => {
          if (item.labelChild && item.labelChild.length > 0) {
            item.labelChild.forEach(aItem => {
              rowArr.push(table[aItem.prop]);
            });
          } else {
            rowArr.push(table[item.prop]);
          }
        });
        ws1.addRow(rowArr);
      });
      const buf = await wb.xlsx.writeBuffer();
      this.saveAs(
        new Blob([buf]),
        `${
          this.purchaseType == 1 ||
          this.purchaseType == 4 ||
          this.purchaseType == 7 ||
          this.purchaseType == 8
            ? "开启"
            : "开标"
        }一览表.xlsx`
      );
    },
    exportBidOpenCompatibleAll() {
      const header = this.bidOpenExportHeaders;
      const filterVal = this.bidOpenExportProps;
      const excelArr = this.exportData;
      let count = 0;
      const list = [];
      excelArr.forEach((val, index) => {
        val.index = ++count;
        list.push(val);
      });
      const data = this.formatJson(filterVal, list);
      exportJsonToExcel({
        header,
        data,
        filename: `${
          this.purchaseType == 1 ||
          this.purchaseType == 4 ||
          this.purchaseType == 7 ||
          this.purchaseType == 8
            ? "开启"
            : "开标"
        }一览表`
      });
    },
    //表格合并单元格
    spanMethod({ row, column, rowIndex, columnIndex }) {
      // 最后一行
      let num = this.tableData[0].bidMarginFlag === "1" ? 9 : 8;
      if (row.index === "downOne" || row.index === "downTwo") {
        if (columnIndex === 1) {
          return [1, num];
        } else if (columnIndex > 1) {
          return [0, 0];
        }
      }
      return [1, 1];
    },
    //定义导出Excel表格事件
    // 开标一览表
    async exportLogin(txt, data) {
      // let data = JSON.parse(JSON.stringify(tabledata));
      if (txt == null) {
        txt = `${
          this.purchaseType == 1 ||
          this.purchaseType == 4 ||
          this.purchaseType == 7 ||
          this.purchaseType == 8
            ? "开启"
            : "开标"
        }一览表`;
      }
      let title = txt;
      console.log("table", data);
      /*  console.log("this.packList", this.packList);
      if (this.packList.length > 0) {
        title = this.packList[this.isFocus].label;
      } */
      const wb = new ExcelJS.Workbook();
      const ws1 = wb.addWorksheet(title);
      ws1.getRow(1).values = [
        `${
          this.purchaseType == 1 ||
          this.purchaseType == 4 ||
          this.purchaseType == 7 ||
          this.purchaseType == 8
            ? "开启"
            : "开标"
        }一览表`
      ];
      ws1.addRow(2).values = "";
      ws1.getCell("A1").alignment = {
        vertical: "middle",
        horizontal: "center"
      };
      ws1.mergeCells("A1:H1");
      ws1.mergeCells("A2:H2");
      // ws1.views = [{ state: "frozen", ySplit: 4 }];
      ws1.getRow(3).values = [
        "序号",
        "分包商",
        "行业类型",
        "企业规模",
        "税额",
        `不含税金额（${this.moneyData.unit}）`,
        `含税金额（${this.moneyData.unit}）`,
        "联系人",
        "手机号",
        "投标时间"
      ];
      ws1.getRow(3).font = {
        bold: true
      };
      ws1.getRow(1).font = {
        bold: true
      };
      ws1.columns = [
        { key: "auto", width: 5 },
        { key: "supName", width: 55 },
        { key: "industryTypeName", width: 30 },
        { key: "companyTypeName", width: 30 },
        { key: "taxAmount", width: 30 },
        { key: "noTaxPriceAmount", width: 30 },
        { key: "priceAmount", width: 30 },
        { key: "contractName", width: 25 },
        { key: "mobile", width: 25 },
        { key: "priceTime", width: 25 }
      ];
      console.log("data", data);
      data.forEach((item, idx) => {
        let taxAmount = item.taxAmount;
        let noTaxPriceAmount = item.noTaxPriceAmount;
        let priceAmount = item.priceAmount;
        ws1.addRow([
          idx + 1,
          item.supName,
          item.industryTypeName,
          item.companyTypeName,
          (taxAmount =
            taxAmount == ""
              ? "0.00000000"
              : new BigNumber(taxAmount).toFormat(2)),
          noTaxPriceAmount == ""
            ? "0.00000000"
            : new BigNumber(noTaxPriceAmount).toFormat(2),
          priceAmount == ""
            ? "0.00000000"
            : new BigNumber(priceAmount).toFormat(2),
          item.contractName,
          item.mobile,
          item.priceTime
        ]);
      });
      for (let i = 1; i <= 200; i++) {
        ws1.getCell(`C${i + 1}`).alignment = {
          vertical: "bottom",
          horizontal: "right"
        };
      }
      for (let i = 1; i <= 200; i++) {
        ws1.getCell(`D${i + 1}`).alignment = {
          vertical: "bottom",
          horizontal: "right"
        };
      }
      for (let i = 1; i <= 200; i++) {
        ws1.getCell(`E${i + 1}`).alignment = {
          vertical: "bottom",
          horizontal: "right"
        };
      }
      const buf = await wb.xlsx.writeBuffer();
      console.log(title);
      if (title.length == 0) {
        title = txt;
      }
      saveAs(new Blob([buf]), `${title}.xlsx`);
    },
    // 开标情况记录表
    async exportDefault(txt, data) {
      let title = "";
      let i = +this.active1;
      console.log("i", i);
      console.log("activeName", this.activeName);
      console.log("data[i].sscSupQuoteListBOS", data[i].sscSupQuoteListBOS);
      if (txt == "") {
        txt = `${
          this.purchaseType == 1 ||
          this.purchaseType == 4 ||
          this.purchaseType == 7 ||
          this.purchaseType == 8
            ? "开启"
            : "开标"
        }情况记录表`;
      }
      /* if (this.packList.length > 0) {
        title = this.packList[this.isFocus].label;
      }
      let unit = parent.window.surcingData.unit; */
      const wb = new ExcelJS.Workbook();
      const ws1 = wb.addWorksheet(title);
      ws1.getRow(1).values = [
        `${
          this.purchaseType == 1 ||
          this.purchaseType == 4 ||
          this.purchaseType == 7 ||
          this.purchaseType == 8
            ? "开启"
            : "开标"
        }情况记录表`
      ];
      ws1.addRow(2).values = "";
      ws1.getCell("A1").alignment = {
        vertical: "middle",
        horizontal: "center"
      };
      ws1.mergeCells("A1:H1");
      ws1.mergeCells("A2:H2");
      // ws1.views = [{ state: "frozen", ySplit: 4 }];
      ws1.getRow(3).values = [
        "序号",
        "分包商名称",
        "采购风险等级",
        "行业类型",
        "企业规模",
        `含税金额（${this.moneyData.unit}）`,
        `不含税金额（${this.moneyData.unit}）`,
        `税额（${this.moneyData.unit}）`,
        this.Myunit,
        "法定代表人资格证书或授权书",
        "投入的人员设备情况",
        "是否有效标书"
      ];
      ws1.getRow(3).font = {
        bold: true
      };
      ws1.getRow(1).font = {
        bold: true
      };
      ws1.columns = [
        { key: "auto", width: 35 },
        { key: "supName", width: 55 },
        { key: "ygyPurchaseRiskLevelStr", width: 30 },
        { key: "industryTypeName", width: 30 },
        { key: "companyTypeName", width: 30 },
        { key: "priceAmount", width: 30 },
        { key: "noTaxPriceAmount", width: 30 },
        { key: "taxAmount", width: 30 },
        { key: "workMonth", width: 25 },
        { key: "isAuthorization", width: 30 },
        { key: "personnelEquipment", width: 25 },
        { key: "isHadAuthorization", width: 25 }
      ];
      data[i].sscSupQuoteListBOS.forEach((item, idx) => {
        let priceAmount = item.priceAmount
          ? new BigNumber(item.priceAmount).toFormat(2)
          : "";
        let taxAmount = new BigNumber(item.taxAmount).toFormat(2)
          ? new BigNumber(item.taxAmount).toFormat(2)
          : "";

        let noTaxPriceAmount = new BigNumber(item.noTaxPriceAmount).toFormat(2)
          ? new BigNumber(item.noTaxPriceAmount).toFormat(2)
          : "";
        taxAmount = taxAmount == "NaN" ? "" : taxAmount;
        noTaxPriceAmount = noTaxPriceAmount == "NaN" ? "" : noTaxPriceAmount;
        let isHadAuthorization = item.isValidBids == 1 ? "是" : "否";
        isHadAuthorization =
          idx == data[i].sscSupQuoteListBOS.length - 2 ||
          idx == data[i].sscSupQuoteListBOS.length - 1
            ? ""
            : isHadAuthorization;
        let isAuthorization =
          item.isAuthorization == 1
            ? "有"
            : item.isAuthorization == 0
            ? "无"
            : "";
        ws1.addRow([
          (idx =
            idx == data[i].sscSupQuoteListBOS.length - 2
              ? "采购交易工作小组会签"
              : idx == data[i].sscSupQuoteListBOS.length - 1
              ? "监督人员会签"
              : idx + 1),
          item.supName,
          item.ygyPurchaseRiskLevelStr,
          item.industryTypeName,
          item.companyTypeName,
          priceAmount,
          noTaxPriceAmount,
          taxAmount,
          item.workMonth,
          isAuthorization,
          item.personnelEquipment,
          isHadAuthorization
        ]);
      });
      for (let i = 1; i <= 200; i++) {
        ws1.getCell(`C${i + 1}`).alignment = {
          vertical: "bottom",
          horizontal: "right"
        };
      }
      for (let i = 1; i <= 200; i++) {
        ws1.getCell(`D${i + 1}`).alignment = {
          vertical: "bottom",
          horizontal: "right"
        };
      }
      for (let i = 1; i <= 200; i++) {
        ws1.getCell(`E${i + 1}`).alignment = {
          vertical: "bottom",
          horizontal: "right"
        };
      }
      const buf = await wb.xlsx.writeBuffer();
      /*  console.log(title);
      if (title.length == 0) {
        title = txt;
      } */
      console.log("txt", txt);
      saveAs(new Blob([buf]), `${txt}.xlsx`);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/config/styles/finereport.scss";
.ddd {
  cursor: pointer;
  color: #0089ef;
}
/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
    //padding: 5px 10px !important;
    //box-sizing: border-box !important;
    //text-overflow: ellipsis !important;
    //white-space: nowrap;
  }
}

/deep/ .el-tabs__customize > .el-tabs__header {
  margin-bottom: 20px !important;
  padding-top: 20px !important;
}

/deep/.el-dialog__body {
  height: 70vh;
  overflow: hidden !important;
}

.pao {
  color: #d3142b;
  font-size: 12px;
  padding-bottom: 10px;
  margin-top: 20px;
  // font-weight: 600;
}
.box {
  display: flex;
  justify-content: space-between;
}
.box1 {
  width: 49%;
}
.red {
  color: #d3142b;
}

.wd6 {
  width: 60px;
}
.wd12 {
  width: 120px;
}
.wd20 {
  width: 200px;
}
.textInfo {
  padding: 1%;
  border: 1px solid #d1d1d1;
  width: inherit;
  max-height: 290px;
  min-height: 200px;
  overflow-y: scroll;
  overflow-wrap: break-word;
}
/deep/ .el-tabs__content {
  position: initial;
}
/deep/ .el-tabs__customize {
  position: relative;
}
.muchDownloadBox {
  position: absolute;
  top: 18px;
  right: 1px;
  z-index: 1003;
}
.ccui-app-iframe-container-detail-body {
  position: relative;
  .exportBtn {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 999;
  }
}
/deep/ .el-tooltip {
  width: 100% !important;
  text-align: left;
}
/deep/ .el-tooltip > .priceClass {
  width: 100% !important;
  text-align: right !important;
}
</style>
<style>
.ccui-top-bar-wrapper {
  display: none;
}
.link-color {
  color: #0089ef;
}
.report-title {
  font-size: 24px;
  text-align: center;
  margin: 20px auto;
}

/* .exportBtn {
  float: right;
  margin-bottom: 10px;
} */
</style>
